// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
// import HomePage from './components/HomePage';
// import SelectCropPage from './components/SelectCropPage';
// import HistoryPage from './components/HistoryPage';

// function App() {
//   return (
//     <Router>
//       <div className="app">
//         <Routes>
//           <Route path="/" element={<HomePage />} />
//           <Route path="/select-crop" element={<SelectCropPage />} />
//           <Route path="/history/:selectedCrop" element={<CustomHistoryPage />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// // CustomHistoryPage component to pass the selected crop
// function CustomHistoryPage() {
//   const { selectedCrop } = useParams();
//   return <HistoryPage selectedCrop={selectedCrop} />;
// }

// export default App;

// -----------------------------------------------------------------

import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import HomePage from './components/HomePage';
import SelectCropPage from './components/SelectCropPage';
import HistoryPage from './components/HistoryPage';
import CurrentDataPage from './components/CurrentDataPage';
import FormPage from './components/FormPage'; // Import the FormPage component

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/select-crop" element={<SelectCropPage />} />
          <Route path="/history/:selectedCrop" element={<CustomHistoryPage />} />
          <Route path="/current-data/:selectedCrop" element={<CustomCurrentDataPage />} />
          <Route path="/form" element={<FormPage />} /> {/* Add a route for the FormPage */}
        </Routes>
      </div>
    </Router>
  );
}

// CustomHistoryPage component to pass the selected crop
function CustomHistoryPage() {
  const { selectedCrop } = useParams();
  return <HistoryPage selectedCrop={selectedCrop} />;
}

// CustomCurrentDataPage component to pass the selected crop
function CustomCurrentDataPage() {
  const { selectedCrop } = useParams();
  return <CurrentDataPage selectedCrop={selectedCrop} />;
}

export default App;
